import { Card, HeaderMenu } from "components";
import { Filter, Table } from "./components";
import { useEffect, useState } from "react";
import { FilterTypeSetStockByLocation } from "./types/SetStockByLocationType";
import { default_pagination_value } from "utils";
import { FormProvider, useForm } from "react-hook-form";
import { useList } from "./hooks";
import { FormSetStockType, stockSchema } from "./schemas/setStockByLocationSchemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateAll } from "./components/CreateAll";
import { useStoreSelectedRows } from "./store";

export default function SetStockByLocation() {

    // state
    const [filter, setFilter] = useState<FilterTypeSetStockByLocation>({
        ...default_pagination_value,
        zero_soh: true,
        zero_min: true,
        zero_max: true
    })

    // store
    const { clear } = useStoreSelectedRows()

    // hooks
    const data = useList(filter)

    // form
    const methods = useForm<FormSetStockType>({
        resolver: yupResolver(stockSchema),
        defaultValues: {
            items: [],
        }
    })

    useEffect(() => {
       clear()
    }, [filter, clear])

    useEffect(() => {
        if (!data?.data?.items?.length) return

        methods.reset({
            items: data.data.items.map(r => ({
                product_id: r.product_id!,
                location_id: Number(filter.location_id)!,
                mr_product_category_id: Number(r.mr_product_category_id) ?? null,
                mr_unit_id: r.unit_convention_id ?? null,
                min_qty: Number(r.min_qty) ?? 0,
                max_qty: Number(r.max_qty) ?? 0,
            })),
        })

        clear()

    }, [data?.data?.items, methods, clear, filter.location_id])

    return (
        <section className="container my-5">
            <HeaderMenu title="SET STOCK BY LOCATION" className="sticky top-[32px] z-[1]" />
            <section className="my-2">
                <section className="mt-2 sticky top-[120px] z-[1]">
                    <Card>
                        <Card.Body>
                            <Filter
                                filter={filter}
                                setFilter={setFilter}
                            />
                        </Card.Body>
                    </Card>
                </section>
            </section>

            <section className="mt-2">
                <Card>
                    <Card.Body>
                        <FormProvider {...methods}>
                            <div>
                                <Table
                                    filter={filter}
                                    setFilter={setFilter}
                                    data={data}
                                />

                                <div className="mt-4 flex justify-end">
                                    <CreateAll 
                                        refecth={data.refetch}
                                    />
                                </div>
                            </div>
                        </FormProvider>

                    </Card.Body>
                </Card>
            </section>
        </section>
    )
}